import { List } from 'immutable'
import { createSelector } from 'reselect'

import { selectSelfServiceConfig } from 'selectors/selectSelfServiceConfig'

export const selectSelfServiceTabs = createSelector(
  [selectSelfServiceConfig],
  (selfServiceConfig) => selfServiceConfig.get('ui_visible_tabs') || new List()
)
